import { get } from 'lodash';

export function getFromGlobal<T>(key: string): T {
  return get(window, key);
}
